import { Navigate, Route } from 'react-router';

import { DEPLOYMENT_STAGE } from '@/env';
import { NotFound } from '@/pages/common/not-found/not-found';
import { DeveloperConfig } from '@/pages/home/developer-config/developer-config';
import { Features } from '@/pages/home/features/features';
import { SwitchAccount } from '@/pages/home/switch-account/switch-account';

export const redirectRoute = (from: string, to: string) => (
  <Route path={from} element={<Navigate to={to} />} />
);

export const developerRoute = ['LOCAL', 'DEV'].includes(DEPLOYMENT_STAGE) ? (
  <Route key="dev" path="/dev-config" element={<DeveloperConfig />} />
) : null;

export const switchAccountRoute = (
  <Route key="switchAccount" path="/switch-account" element={<SwitchAccount />} />
);

export const notFoundRoute = <Route key="notFound" path="*" element={<NotFound />} />;

/**
 * These routes are only available to Invenco users in production but are available to all users in
 * LOCAL, DEV and STAGE
 */
export function featureRoute(isInvencoUser: boolean) {
  if (isInvencoUser || DEPLOYMENT_STAGE !== 'PROD') {
    return <Route key="features" path="/features" element={<Features />} />;
  }
  return null;
}

export const commonRoutes = (isInvencoUser = false) => [
  switchAccountRoute,
  developerRoute,
  notFoundRoute,
  featureRoute(isInvencoUser),
];
